import Fetch from "./index";

export const getFeegowIntegration = async ({ assistantID }) => {
    if (!assistantID)
        return Promise.reject("failed to read id");

    return Fetch("/feegow-integration/?assistantID=" + assistantID)
}

export const createFeegowIntegration = async (body) => {
    const data = new FormData();
    for (const key in body) {
        if (Array.isArray(body[key])) {
            for (const value of body[key]) {
                data.append(key + "[]", value);
            }
            continue
        }
        data.set(key, body[key]);
    }

    return Fetch(
        '/feegow-integration/',
        {
            method: 'POST',
            body: data,
        },
    )
}

export const updateFeegowIntegration = async (id, body) => {
    delete body['createdAt']
    delete body['updatedAt']
    delete body['deletedAt']
    delete body['id']

    const data = new FormData();
    for (const key in body) {
        if (Array.isArray(body[key])) {
            for (const value of body[key]) {
                data.append(key + "[]", value);
            }
            continue
        }
        data.set(key, body[key]);
    }

    return Fetch(
        '/feegow-integration/' + id,
        {
            method: 'PUT',
            body: data,
        },
    )
}

export const deleteFeegowIntegration = async (id) => {
    return Fetch(
        '/feegow-integration/' + id,
        {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}
